import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule, TranslateLangPipe } from '@gs-2.0/shared';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';

import { PortalCoreModule } from '../../_core/core.module';
import { PortalSharedModule } from '../../_shared/shared.module';
import { TransferFormComponent } from './form/form.component';
import { TransferSummaryComponent } from './summary/summary.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PortalCoreModule,
    PortalSharedModule,
    SharedModule,
    TranslateLangPipe,
    RadioButtonModule,
    CheckboxModule,
    DatePickerModule,
    InputNumberModule,
    SelectModule,
  ],
  declarations: [TransferFormComponent, TransferSummaryComponent],
  exports: [TransferFormComponent, TransferSummaryComponent],
})
export class TransferComponentsModule {}
